import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
import ReactDataTable from "../../../Common/ReactDataTable";
import TreeView from "../../../Common/TreeView";
import Alert from "../../../Common/Alert";

const List = () => {
  const location = useLocation();
  const [parents, setParents] = useState([]);
  const [selected, setSelected] = useState([]);
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [inputs, setInputs] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/tree-chart-of-account-code`);
      setParents(res.data.parents);
      setReceiveData(res.data.chart_of_accounts);
      setFilteredData(res.data.chart_of_accounts);
      setSelected(res.data.selected_parent);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  // Search filtering logic
  const filterAccounts = (accounts, searchTerm) => {
    if (!searchTerm.trim()) {
      return accounts;
    }

    const filtered = [];
    const searchLower = searchTerm.toLowerCase();

    const searchInTree = (nodes, parentMatched = false) => {
      const result = [];

      nodes.forEach((node) => {
        const nameMatches =
          node.name && typeof node.name === "string"
            ? node.name.toLowerCase().includes(searchLower)
            : false;
        const codeMatches =
          node.code && typeof node.code === "string"
            ? node.code.toLowerCase().includes(searchLower)
            : false;
        const currentMatches = nameMatches || codeMatches;

        let childrenResult = [];
        if (node.children_recursive && node.children_recursive.length > 0) {
          childrenResult = searchInTree(
            node.children_recursive,
            currentMatches || parentMatched
          );
        }

        // Include node if:
        // 1. Current node matches search term
        // 2. Parent matched (show all children of matching parent)
        // 3. Has matching children (show parent of matching children)
        if (currentMatches || parentMatched || childrenResult.length > 0) {
          result.push({
            ...node,
            children_recursive: childrenResult,
          });
        }
      });

      return result;
    };

    return searchInTree(accounts);
  };

  // Update filtered data when search term or receive data changes
  useEffect(() => {
    const filtered = filterAccounts(receiveData, searchTerm);
    setFilteredData(filtered);
  }, [searchTerm, receiveData]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Chart Of Accounts Lists</h5>
            <Link to="/create-chart-of-account" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>Create new Chart Of
              Account
            </Link>
          </div>
          <div className="am-pagebody modern-body">
            <div className="content-card">
              {/* Search Input */}
              <div
                className="search-container mb-4"
                style={{
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  border: "1px solid #e9ecef",
                }}
              >
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="input-group">
                      <span
                        className="input-group-text"
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRight: "none",
                        }}
                      >
                        <i className="fa fa-search text-muted"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search accounts by name or code..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{
                          border: "1px solid #ced4da",
                          borderLeft: "none",
                          fontSize: "0.95rem",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <small className="text-muted">
                      <i className="fa fa-info-circle me-1"></i>
                      Search by account name or code. Parent account search will
                      show all children.
                    </small>
                  </div>
                </div>
                {searchTerm && (
                  <div className="mt-2">
                    <small className="text-info">
                      <i className="fa fa-filter me-1"></i>
                      Showing results for: <strong>{searchTerm}</strong>
                      <button
                        className="btn btn-link btn-sm p-0 ms-2 text-decoration-none"
                        onClick={() => setSearchTerm("")}
                        style={{ fontSize: "0.8rem" }}
                      >
                        <i className="fa fa-times"></i> Clear
                      </button>
                    </small>
                  </div>
                )}
              </div>
              {loading ? (
                <div className="loading-container text-center py-5">
                  <div className="spinner-container">
                    <i className="fa fa-spinner fa-spin fa-3x text-primary mb-3"></i>
                    <h5 className="text-muted">Loading Chart of Accounts...</h5>
                    <p className="text-muted small">
                      Please wait while we fetch your account data
                    </p>
                  </div>
                </div>
              ) : (
                <TreeView data={filteredData} actionTemplate={actionTemplate} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const actionTemplate = (item, deleteData) => {
  return (
    <td className="text-xs">
      <Link
        to={{
          pathname: "/edit-chart-of-account/" + item.id,
        }}
        className="btn btn-primary btn-sm"
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </Link>
      &nbsp;
      <Link
        to={{
          pathname: "/chart-of-account-ledger/" + item.id,
        }}
        className="btn btn-info btn-sm"
      >
        <i className="fa fa-list" aria-hidden="true"></i>
      </Link>
    </td>
  );
};
export default List;
